import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const toggleSidebar = createAsyncThunk("/sidebar", async (value) => {
  return value;
});

const appSlice = createSlice({
  name: "app",
  initialState: {
    isSidebarOpen: true,
  },
  reducers: {
    clearAuthRedirectState: (state) => {
      state.redirect = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(toggleSidebar.fulfilled, (state, action) => {
      state.isSidebarOpen = action.payload;
    });
  },
});

const { reducer } = appSlice;
export default reducer;
